export const CLASS_TOGGLE_DATA = 'js-class-toggle';
